import axios from 'axios'

class SignerTypeService {
  constructor(apiUrl) {
    this.apiUrl = apiUrl
  }

  /**
  * @author Lucia Alvarado
  * @description 
  * @date 29-07-2020
  * @param {String} token
  * @param {Object} address
  * @returns {Object}
  * @memberof 
  */
  async getSignerTypes(token) {
    let response = await axios.get(`${this.apiUrl}/signer-types`,
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
    return response.data.data
  }



}

export { SignerTypeService as default }